module.exports = __webpack_public_path__ + "static/img/icon_mrqd.f12e952d.png";